<template>
  <div class="receiving-search">
    <custom-input
      label="Заказчик"
      class="receiving-search__input"
      :model-value="searchQuery"
      :focus="!props.modelValue"
      clearable
      @update:model-value="handleQuery"
      @clear="handleClear"
    />
    <div v-if="items.length" class="receiving-search__list">
      <p
        v-for="item in items"
        :key="item.id"
        class="receiving-search__item"
        @click="handleSelect(item)"
      >
        {{ item.name }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>

import { onMounted, ref, watch } from 'vue'
import { iClient } from '@/types/responses'
import useDataRequest from '@/composables/useDataRequest'
import { getClientById, suggestClient } from '@/api/client'

const props = defineProps<{
  modelValue?: number|null
}>()

const emit = defineEmits(['update:modelValue'])

const items = ref<iClient[]>([])

const searchQuery = ref<string>()
const currentId = ref<number|undefined>()
const request = useDataRequest()

const handleQuery = (term: string) => {
  if (term) {
    searchQuery.value = term
    request.tryRequest(async () => {
      const response = await suggestClient(term)
      items.value = response.data
    })
  }
}

const handleSelect = (client: iClient) => {
  currentId.value = client.id
  searchQuery.value = client.name
  items.value = []
  emit('update:modelValue', client.id)
}

const loadCurrentClientName = () => {
  request.tryRequest(async () => {
    if (props.modelValue && props.modelValue !== currentId.value) {
      const response = await getClientById(props.modelValue)
      searchQuery.value = response.data.name
    }
  })
}

const handleClear = () => {
  searchQuery.value = ''
  currentId.value = undefined
  emit('update:modelValue', null)
}

onMounted(loadCurrentClientName)

watch(() => props.modelValue, loadCurrentClientName)

</script>
